/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */
export class SfToken {
	constructor(public description: string) { }
}
